module.exports = __webpack_public_path__ + "img/img_06.a320122d.png";